import { ReactComponent as Dancer } from '../../public/images/svg/Dance-02-WF.svg';
import { Rotation } from '../Models/SkitterbookLivePagesRequest';
import { RadioGroup } from "../Controls/RadioGroup";
import './css/SkitterBookRotation.css';

interface SkitterBookRotationProps {
    value: Rotation;
    onChange?: (value: Rotation) => void;
}

export const SkitterBookRotation: React.FC<SkitterBookRotationProps> = ({
    value,
    onChange
}) => {
    function NaturalRotationGraphic() {
        return (<div className="sko-page natural">
            <div className="sko-page-image">
                <Dancer viewBox="0 0 17.75 32.27" width="14.2" height="25.816" />
            </div>
        </div>)
    }
    function EdgeRotationGraphic() {
        return (<div className="sko-page edge">
            <div className="sko-page-image">
                <Dancer viewBox="0 0 17.75 32.27" width="14.2" height="25.816" />
            </div>
        </div>)
    }
    function InverseRotationGraphic() {
        return (<div className="sko-page inverse">
            <div className="sko-page-image">
                <Dancer viewBox="0 0 17.75 32.27" width="14.2" height="25.816" />
            </div>
        </div>)
    }

    return (
        <div className="sbe-container sbe-rotation-container">
            <RadioGroup<Rotation>
                name="rotationGroup"
                value={value}
                onChange={(val: Rotation) => {
                    onChange?.(val);
                }}
                options={[
                    { value: "0", label: <NaturalRotationGraphic /> },
                    { value: "90", label: <EdgeRotationGraphic /> },
                    { value: "180", label: <InverseRotationGraphic /> }
                ]}
                colors={{
                    border: "var(--color-static-background)",
                    foreground: "var(--color-component-foreground)",
                    background: "var(--color-component-background)",
                    hover: "var(--color-component-foreground)"
                }}
                className="rotation-group"
            />
        </div>
    );
};

export default SkitterBookRotation;
